import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import { GetTheAppProvider } from './components/GetTheApp';
import Landing from './pages/Landing';
import Profile from './pages/Profile';
import Book from './pages/Book';
import Entry from './pages/Entry';

/**
 * longreads.me is a reading room for long reads.
 *
 * There is no sign-in here: accounts, saving, subscribing and writing live in
 * the app. Anything a visitor taps that would write opens the "get the app"
 * prompt instead — see components/GetTheApp.
 *
 * The routes deliberately match the deep links the app already emits
 * (longreads-app/src/utils/links.ts, and the `linking` config in
 * AppNavigator.tsx), so a link shared from a phone opens the app when it is
 * installed and lands here when it is not.
 */
function App() {
  return (
    <GetTheAppProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/read/:seriesId" element={<Book />} />
        <Route path="/read/:seriesId/:entryId" element={<Entry />} />
        {/* Anything else is treated as a username, so longreads.me/chris works. */}
        <Route path="/:username" element={<Profile />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </GetTheAppProvider>
  );
}

export default App;
